import React, { Component } from 'react';
import ReactApexChart from 'react-apexcharts';


class Charts extends Component {
    constructor(props) {
        super(props);

        this.state = {
            series: [{
                name: 'Comprado',
                data: [20000, 310000, 400000, 1010000, 400000, 360000, 320000, 230000, 140000, 80000, 50000, 20000],
                color: '#dc3545' // Define a cor das barras
            }],

            options: {
                chart: {
                    height: 350,
                    type: 'bar',
                },
                plotOptions: {
                    bar: {
                        borderRadius: 10,
                        dataLabels: {
                            position: 'top',
                        },
                        colors: {
                            ranges: [{
                                from: 0,
                                to: 1000000, // Ajuste o intervalo conforme necessário
                                color: '#dc3545' // Define a cor das barras
                            }]
                        }
                    }
                }
                ,
                dataLabels: {
                    enabled: true,
                    formatter: function (val) {
                        return `R$ ${val.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`;
                    },
                    offsetY: -20,
                    style: {
                        fontSize: '12px',
                        colors: ["#304758"]
                    }
                }
                ,
                xaxis: {
                    categories: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
                    position: 'top',
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    },
                    crosshairs: {
                        fill: {
                            type: 'gradient',
                            gradient: {
                                colorFrom: '#D8E3F0',
                                colorTo: '#BED1E6',
                                stops: [0, 100],
                                opacityFrom: 0.4,
                                opacityTo: 0.5,
                            }
                        }
                    },
                    tooltip: {
                        enabled: true,
                    }
                },
                yaxis: {
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false,
                    },
                    labels: {
                        show: true, // Mostra os valores no eixo Y
                        formatter: function (val) {
                            return `R$ ${val.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}`;
                        }
                    }
                }
                ,
                title: {

                    floating: true,
                    offsetY: 330,
                    align: 'center',
                    style: {
                        color: 'rgb(107, 107, 107)'
                    }
                }
            },
        };
    }

    render() {
        return (
            <div>
                <hr></hr>
                <div id="chart">
                    <ReactApexChart options={this.state.options} series={this.state.series} type="bar" height={350} />
                </div>
            </div>
        );
    }
}

export default Charts;
